import { Box, Button, Text } from "@mantine/core";
import React from "react";

export const NewAddButton = ({
  title,
  icon,
  onClick,
  color,
  textColor,
  variant,
  borderColor,
}) => {
  return (
    <Button
      title={title}
      size="md"
      radius="md"
      variant={variant}
      onClick={onClick}
      style={{
        backgroundColor: color,
        color: textColor,
        border: `1px solid ${borderColor ? borderColor : "transparent"}`,
        // borderColor: borderColor ? borderColor : "transparent",
      }}
    >
      {icon && <Box mr={10}>{icon}</Box>}
      <Text>{title}</Text>
    </Button>
  );
};
